import Modal from "../../components/modal";
import { PageWithGif } from "../../components/page";
import "./safety_and_sec.css";

export default function SafetyProjectPage() {
  return (
      <div>
        <PageWithGif
            gifURL={
              "https://static.igem.wiki/teams/4260/wiki/safety-project/1-safety-fondosolution-2.gif"
            }
        >
          <div className="relative h-full w-full flex justify-center items-end text-white">
            <div
                className="absolute rounded-xs p-16 m-auto"
                style={{
                  overflow: "scroll",
                  top: 0,
                  left: 0,
                  width: "70%",
                  height: "70%",
                  bottom: 0,
                  right: 0,
                  backgroundColor: "rgba(69, 41, 107,0.70)",
                  textAlign: "justify",
                }}
            >
              <h1
                  className="mb-5 text-6xl font-bold"
                  style={{ fontFamily: "Cano", color: "rgb(255, 231, 135)" }}
              >
                Safety Project
              </h1>
              <div className="relative flex justify-center items-end text-white">
                <iframe
                    title="TecCEM: Safety Clip (2022) [English]"
                    width="560"
                    height="315"
                    src="https://video.igem.org/videos/embed/ad3967d8-7f63-4acb-9099-5f3b54cca757"
                    frameborder="0"
                    allowfullscreen=""
                    sandbox="allow-same-origin allow-scripts allow-popups"
                ></iframe>
              </div>
              <br></br>
              <h1
                  className="mb-5 text-6xl font-bold"
                  style={{ fontFamily: "Cano", color: "rgb(255, 231, 135)" }}
              >
                Problem
              </h1>
              <p className="p-justify">
                Over time, humanity has widely used antibiotics principally for
                their high effectiveness and low cost. Beyond the treatment of
                infections, antibiotics are great selectable markers for molecular
                biology procedures. They can help identify cells that have been
                efficiently transformed [1]. Genetic transformation consists of
                the insertion of foreign DNA into a host cell, usually in an
                expression cassette. DNA delivery is commonly carried out in 2
                ways: by direct DNA transfer either utilizing viral properties or
                microorganisms such as Agrobacterium tumefaciens. Regardless of
                the method used for the genetic transformation, a selectable
                marker must be used to verify the correct insertion of DNA [1].
              </p>
              <p className="p-justify">
                There are different types of selectable markers and some of the
                most commonly used are those based on confering microorganisms the
                ability to resist the presence of antibiotics [2]. With this
                mechanism, we can be confident to only obtain growth of the
                microorganism we have conferred resistance to since all others
                will die; however, this has raised multiple concerns due to the
                risk it represents towards the environment and human health.{" "}
                <label
                    htmlFor="problem_moreInfo_modal"
                    className="underline text-blue-400"
                >
                  [more information]
                </label>
              </p>
              <img
                  src="https://static.igem.wiki/teams/4260/wiki/fig1-sp.png"
                  alt="Fig1-sp"
                  className="figure"
              />
              <p className="figure_desc ">
                <strong><i>Figure 1. Antibiogram comparison.</i></strong> It can be
                observed how the inhibition of antibiotics has decreased
                considerably; halos from the left petri dish are much bigger than
                those of right petri dish. [Photograph: Science History
                Images/Alamy, retrieved from “The Guardian”]
              </p>
              <p className="p-justify">
                Antibiotic resistance or “antimicrobial resistance” is the term
                used to define this problem. Throughout the years, the number of
                microorganisms that have become resistant to commonly used
                antibiotics has increased, growing concern around the world
                because of the morbidity and mortality rates it is associated to
                [5]. In fact, a review commissioned by the United Kingdom
                government argued that by 2050, 10 million people per year will
                die due to antimicrobial resistance [6].
              </p>
              <p className="p-justify">
                In 2016 Jasovský, Littmann, Zorzet & Cars determined that 214,000
                neonatal deaths from sepsis per year were attributed to
                “drug-resistant pathogens [7], They also mentioned that “In
                summary, drug-resistant pathogens could reverse the recent
                positive trend of falling global mortality rates from infectious
                diseases, which have decreased from 23% to 17% of total deaths
                over the last 15 years” being this alarming but also realistic
                conclusions [7]
              </p>
            </div>
          </div>
          <Modal modalId="problem_moreInfo_modal">
            <h3 className="h3">More Information</h3>
            <p className="p-justify">
              A selection marker is a gene inserted into both, cloning and
              expression vectors, that helps host cells produce enzymes that allow
              them to defend themselves from the action mechanism of antibiotics.
              The most commonly used antibiotics (such as penicillin, ampicillin,
              amoxicillin, cephalosporins, and others) are “beta-lactams” [3],
              these inhibit the proper peptidoglycan (a component of bacterial
              cell wall), thus the gene in selection markers that aim to give
              bacteria resistance towards beta-lactams have to coding sequence for
              beta-lactamase enzyme. This can hydrolyze beta-lactams, allowing the
              synthesis of the cell wall and allowing the bacteria to live [4].
            </p>
          </Modal>
        </PageWithGif>
        <PageWithGif
            gifURL={
              "https://static.igem.wiki/teams/4260/wiki/safety-project/2-safety-fondodesign-1.gif"
            }
        >
          <div className="relative h-full w-full flex justify-center items-end text-white">
            <div
                className="absolute rounded-xs p-16 m-auto"
                style={{
                  overflow: "scroll",
                  top: 0,
                  left: 0,
                  width: "70%",
                  height: "70%",
                  bottom: 0,
                  right: 0,
                  backgroundColor: "rgba(69, 41, 107,0.70)",
                }}
            >
              <h1
                  className="mb-5 text-6xl font-bold"
                  style={{ fontFamily: "Cano", color: "rgb(255, 231, 135)" }}
              >
                Solution
              </h1>
              <p className="p-justify">
                In spite of this, antibiotics are necessary for synthetic biology
                experimental procedures. Therefore, the objective of this year’s
                TecCEM’s safety project was to create an alternative to
                antibiotic-based selection markers, being our main focus on its
                functionality with the most commonly used microorganism
                Escherichia coli, and contribute to the reduction of antibiotic
                use in laboratories.
              </p>
              <p className="p-justify">
                Once having understood the action system of selection markers, as
                a first step it was necessary to find a replacement for
                antibiotics as an inhibitory compound. For this purpose, we
                decided to look for compounds in natural substances that were
                known for having antimicrobial activity, such as honey, cinnamon,
                garlic, and others. Secondly, it was crucial to find reported
                genes that could help the microorganism degrade the inhibitory
                compound. And finally, it was important to consider that the final
                product of the conversion of the chosen compound was not capable
                of causing cell death.
              </p>
              <p className="p-justify">
                The starting point was research about essential oils, from which
                we learned that cinnamon and clover essential oils were
                outstanding for their inhibitory action, related to the presence
                of the aromatic compound: eugenol, being present in over 70% in
                cinnamon essential oil [8]. Over all other inhibitory compounds,
                this one caught our attention because it is commercialized as a
                pure component, thus no extraction from cinnamon oil would be
                necessary, representing an advantage. However, when looking up the
                degradation pathway of this compound, many steps were involved in the
                transformation of eugenol, meaning that the bacteria would have to
                express them all and code for those proteins in order to degrade
                it; and usually ,the expression of too many genes is complicated
                [9]. With this in mind, we decided to explore other options and
                eventually found isoeugenol, the isomer of eugenol.
              </p>

              <p className="p-justify">
                Isoeugenol belongs to the group of phenylpropenes and has shown
                comparable and even superior antimicrobial activity to its highly
                antimicrobial original form eugenol [10], probably owed to its
                free hydroxyl group and its position of double bonds in the α, and
                β positions of the side chain, and a methyl group in the γ
                position (<strong>Figure 2</strong>) [11].
              </p>
              <img
                  src="https://static.igem.wiki/teams/4260/wiki/isoeugenol-sinfondo.png"
                  alt="Fig1-sp"
                  className="figure"
              />
              <p className="figure_desc ">
                <strong><i>Figure 2. 3D Structure of Isoeugenol.</i></strong> Image
                generated with Discovery Studio.
              </p>
              <p className="p-justify">
                Isoeugenol’s antimicrobial activity covers a wide range of
                gram-positive and gram-negative bacteria, including Escherichia
                coli, Bacillus licheniformis, Micrococcus luteus, Pseudomonas
                aeruginosa, Salmonella type B, Staphylococcus aureus [10], as well
                as other microorganisms like Saccharomyces cerevisiae, and
                Aspergillus nigger [12], which means that it could lead to the
                development of a selection marker useful not only for bacteria but
                also fungi and yeasts. Its action mechanism consists of altering
                the integrity of the inner membrane of bacteria, causing spillage
                of fluids and cell death [10].
              </p>
              <p className="p-justify">
                Nevertheless, there are reports of other microorganisms that are
                able to metabolize it, such as Pseudomonas bacteria (known for
                being able to grow under harsh conditions) by the action of the
                enzyme Isoeugenol Monooxygenase (<strong>Figure 3</strong>), which allows a one-step conversion
                of it into vanillin. Isoeugenol monooxygenase (IsoMo), reported by Yamada, Okada, Yoshida &
                Nagasawa in 2008 besides from this, it does not lead to the
                formation of undesired co-products that could have an inhibitory
                effect on E. coli, such as vanillic acid or acetaldehyde [13].
                Vanillin, on its own, causes an inhibition on E. coli but at much
                higher concentrations than isoeugenol [14].
              </p>
              <img
                  src="https://static.igem.wiki/teams/4260/wiki/safety-project/isomo-sinfondo.png"
                  alt="Fig1-sp"
                  className="figure"
              />

              <p className="figure_desc ">
                <strong><i>
                  Figure 3. 3-D model of Isoeugenol Monooxygenase (IsoMo).</i>
                </strong>
                The model of IsoMo shows that its tertiary structure is composed
                mostly by β sheets and random coils. [Obtained from ITASSER].
              </p>

              <p className="p-justify">
                After determining that isoeugenol and IsoMo were, together, going
                to be used as a selection system, codon optimization and a 3D structure
                was obtained with ITASSER. With this,
                static molecular docking was performed in AutodockVina (
                <strong>Figure 4</strong>), in order to analyze the interactions
                between the enzyme and its substrate (isoeugenol), using as a
                starting point the residues of the active site reported by Ryu,
                Seo, Park, Ahn, Chong, Sadowsky & Hur (2013): H167, H218, H282,
                H471, E135, E349 & E413 [15]. A binding energy score of -6.4 and a
                forming hydrogen bond with Met350.
              </p>
              <img
                  src="https://static.igem.wiki/teams/4260/wiki/safety-project/fig6-sp-t.png"
                  alt="Fig1-sp"
                  className="figure"
              />
              <p className="figure_desc ">
                <strong><i>
                  Figure 6. Result of molecular docking of IsoMo (purple) and
                  Isoeugenol (yellow).</i>
                </strong>{" "}
                The hydrogen bond with Met350 is highlighted in blue. Own figure.
              </p>
            </div>
          </div>
        </PageWithGif>
        <PageWithGif
            gifURL={
              "https://static.igem.wiki/teams/4260/wiki/safety-project/3-implementation-safety-compressed-1.gif"
            }
        >
          <div className="relative h-full w-full flex justify-center items-end text-white">
            <div
                className="absolute rounded-xs p-16 m-auto"
                style={{
                  overflow: "scroll",
                  top: 0,
                  left: 0,
                  width: "70%",
                  height: "70%",
                  bottom: 0,
                  right: 0,
                  backgroundColor: "rgba(69, 41, 107,0.70)",
                  textAlign: "justify",
                }}
            >
              <h1
                  className="mb-5 text-6xl font-bold"
                  style={{ fontFamily: "Cano", color: "rgb(255, 231, 135)" }}
              >
                Design + Build
              </h1>
              <p className="p-justify">
                For the design of the selection marker, two genetic constructs
                were made: one directly inducible by isoeugenol (Pp_22:{" "}
                <a
                    className="underline text-blue-600"
                    href="http://parts.igem.org/Part:BBa_K4260006"
                >
                  BBa_K4260006
                </a>
                ) and other regulated by a constitutive promoter (Nc_22:{" "}
                <a
                    className="underline text-blue-600"
                    href="http://parts.igem.org/Part:BBa_K4260007"
                >
                  BBa_K4260007
                </a>
                ); this, in order to test the efficiency of the two systems.
              </p>

              <p className="p-justify">
                In addition, 28 bp were added upstream from the prefix, and 19 bp
                downstream from the suffix, aiming to allow hybridization of the
                primers HF_22 and HR_22 designed by TecCEM’s 2021 team, for the
                two sequences.
              </p>
              <p className="p-justify">
                Pp_22, (<strong>Figure 5.</strong>) is a 2807 bp long Biobrick,
                that includes a bidirectional promoter that regulates the
                transcription of Iso (coding gene of IsoMo) and a
                transcriptional activator [17], in the 5’ to 3’ and 3’ to 5’ direction, respectively.
              </p>

              <img
                  src="https://static.igem.wiki/teams/4260/wiki/safety-project/brick6.png"
                  alt="Fig1-sp"
                  className="figure"
              />
              <p className="figure_desc ">
                <strong><i>Figure 5. Components of Pp_22 (BBa_K4260006).</i></strong> The
                components of the BioBrick are respectively represented in the
                scheme.
              </p>
              <p className="p-justify">
                Nc_22 (<strong>Figure 6</strong>) on its own is 1712 bp long. It
                is a shorter sequence that shares the Iso gene and rrnB T1
                terminator in common with Pp_22. However, this construct includes
                the strongest constitutive promoter reported:
                <a
                    className="underline text-blue-600"
                    href="http://parts.igem.org/Part:BBa_J23100"
                >
                  BBa_J23100
                </a>
                , as well as a ribosome binding site (RBS:{" "}
                <a
                    className="underline text-blue-600"
                    href="http://parts.igem.org/Part:BBa_B0030"
                >
                  BBa_B0030
                </a>
                ). For this case, the single appearance of the 4 restriction sites
                was also ensured, to avoid undesired cuts within the sequence.
              </p>
              <img
                  src="https://static.igem.wiki/teams/4260/wiki/safety-project/biobrick7.png"
                  alt="Fig1-sp"
                  className="figure"
              />
              <p className="figure_desc ">
                <strong><i>Figure 6. Components of Nc_22 (BBa_K4260007). </i></strong>The
                components of the BioBrick are respectively represented in the
                scheme. represented in the scheme.
              </p>
            </div>
          </div>
        </PageWithGif>
        <PageWithGif
            gifURL={
              "https://static.igem.wiki/teams/4260/wiki/safety-project/4-the-problem-safety-compressed-1.gif"
            }
        >
          <div className="relative h-full w-full flex justify-center items-end text-white">
            <div
                className="absolute rounded-xs p-16 m-auto"
                style={{
                  overflow: "scroll",
                  top: 0,
                  left: 0,
                  width: "70%",
                  height: "70%",
                  bottom: 0,
                  right: 0,
                  backgroundColor: "rgba(69, 41, 107,0.70)",
                  textAlign: "justify",
                }}
            >
              <h1
                  className="mb-5 text-6xl font-bold"
                  style={{ fontFamily: "Cano", color: "rgb(255, 231, 135)" }}
              >
                Results
              </h1>
              <p className="p-justify">
                For this section, experimental results are divided in three main
                sections, according to our specific objectives. For each section,
                it was intended to emphasize the application of the iGEM
                Engineering Cycle, shown in <strong>Figure 7</strong>, by
                establishing what the design was built on, put to test, and how
                the results obtained for each stage helped us direct the next
                steps in our investigation.
              </p>

              <img
                  src="https://static.igem.wiki/teams/4260/wiki/cycle.png"
                  alt="Fig1-sp"
                  className="figure"
              />
              <p className="figure_desc ">
                <strong>
                  <center><i>Figure 7. iGEM Engineering Cycle.</i></center>
                </strong>
              </p>
              <br></br>
              <hr></hr>
              <p className="p-justify">
                <em>
                  <u>
                    1) Accomplishment of a homogeneous distribution of isoeugenol
                    culture mediums
                  </u>
                </em>
              </p>
              <p className="p-justify">
                As a first stage of the project, experimental procedures were
                designed focused on the development of culture mediums with
                isoeugenol, in regard to the Minimum Inhibitory Concentration
                (MIC), to be able to move on to the next phase. For this purpose,
                different procedures were tested for both liquid and solid Luria
                Bertani (LB) culture mediums and different concentrations of
                isoeugenol.
              </p>
              <p className="p-justify">
                <em>1.1. Ordinary procedure</em>
              </p>
              <img
                  src="https://static.igem.wiki/teams/4260/wiki/safety-project/figura-10.png"
                  alt="Fig1-sp"
                  className="figure"
              />
              <img
                  src="https://static.igem.wiki/teams/4260/wiki/safety-project/figura-10b.png"
                  alt="Fig1-sp"
                  className="figure"
              />
              <p className="figure_desc ">
                <strong><i>
                  Figure 8. Methodology diagram for the ordinary preparation of
                  culture mediums.{" "}</i>
                </strong>{" "}
                1) Treatment “A”: Addition of isoeugenol before sterilization. 2)
                Tretament “B”: Addition of isoeugenol after sterilization.
              </p>
              <p className="p-justify">
                The methodology shown in Figure 8 was firstly tested with serial
                dilutions x10^-4 and x10^-5 of E. coli DH5α, to analyze the
                inhibitory effect of isoeugenol on the growth of E. coli using the
                concentrations reported in Table 1. However, after removing the
                media from the autoclave, droplets of isoeugenol could be seen
                settling at the bottom of the flasks or falcon tubes (Figure 9).
                Thus, it was determined that the sterilization process conditions
                were insufficient to ensure that the isoeugenol was adequately
                homogenized in the media.
              </p>
              <img
                  src="https://static.igem.wiki/teams/4260/wiki/safety-project/b4c4.png"
                  alt="Fig1-sp"
                  className="figure"
              />
              <p className="figure_desc ">
                <strong><i>
                  Figure 9. Treatment B, concentration 4, liquid medium.{" "}</i>
                </strong>
                Isoeugenol can be observed at the bottom as a small drop.
              </p>
              <br></br>
              <p className="figure_desc ">
                <strong>
                  Table 1. Isoeugenol concentrations used for treatments A and B
                </strong>
              </p>
              <img
                  src="https://static.igem.wiki/teams/4260/wiki/safety-project/tables/table-1-isoeugenol-concentrations.png"
                  alt="Fig1-sp"
                  className="figure"
              />

              <p className="p-justify">
                <em>1.2. Mechanic emulsification with the Polytron</em>
              </p>
              <p className="p-justify">
                Since it was noticed that isoeugenol was not dissolving in the
                mediums despite the small amounts that were being used, we decided
                to try to emulsify it with the Polytron homogenizer.
              </p>
              <p className="p-justify">
                For this experiment, the Polytron was cleaned with a 70% (v/v)
                solution of ethanol, irradiated with UV light in the laminar flow
                hood, and rotated after every 15 minutes to make sure all sides of
                the equipment were sterilized. After this, falcon tubes with LB
                mediums with isoeugenol, prepared according to treatment A were
                emulsified for 10 minutes, cleaning the tip of the Polytron with
                distilled water in between each tube.
              </p>
              <p className="p-justify">
                Unfortunately, this procedure was not effective either. Moments
                after the emulsification, isoeugenol started sedimenting again at
                the bottom of all falcon tubes. Besides, it was discovered that
                the sterilization protocol used for the Polytron had not been
                sufficient for its actual sterilization, since all mediums got
                contaminated. Therefore, other options needed to be explored.
              </p>
              <br></br>
              <p className="p-justify">
                <em>1.3. Chemical emulsification with Tween 80</em>
              </p>
              <p className="p-justify">
                As no positive results were obtained from the mechanical
                emulsification method used, as an alternative Tween 80 emulsifier
                was added to liquid culture mediums.{" "}
                <label
                    htmlFor="problem_moreInfo_modal1"
                    className="underline text-blue-400"
                >
                  [more information]
                </label>
              </p>
              <p className="p-justify">
                Tween 80 was tested at 4%, 6%, and 10% of the total volume of
                isoeugenol; it was added at the same time as isoeugenol. What
                happened with the Tween 80 was not only that no improvement was
                observed in the homogenization or emulsification of the samples,
                but also that dirt was present in all the mediums. For this
                reason, and considering its toxicity for E. coli, it was decided
                that it was better to not use this compound in the medium
                formulation.
              </p>
              <br></br>
              <p className="p-justify">
                <em>1.4. Mechanical emulsification with Vortex and Sonicator</em>
              </p>
              <p className="p-justify">
                In order to avoid using other compounds that could have an
                inhibitory effect on bacterial growth, it was decided to go back
                to mechanical methods. Therefore, emulsification was carried out,
                first by vortexing and second, by sonication of the mediums.
              </p>


              <br></br>
              <p className="p-justify">
                <em>1.5. Homogeneity analysis in ZetaSizer</em>
              </p>
              <p className="p-justify">
                Despite the good results obtained,
                more tests were run and evaluated in order to check out the
                treatment that could provide a better homogeneity of the mediums
                at a concentration of 4.5 mM of isoeugenol (Table 2 and Table 3).
                The use of Tween 80, the use of the vortex , the resting time of
                mediums and the effect of sonication time prior and after
                autoclaving were evaluated through the Zetasizer instrument as
                shown on.{" "}
                <label
                    htmlFor="problem_moreInfo_modal3"
                    className="underline text-blue-400"
                >
                  [more information]
                </label>
              </p>
              <p className="figure_desc ">
                <br></br>
                <strong>
                  Table 2. Different treatments for 4.5 mM of isoeugenol for its
                  analysis in ZetaSizer.{" "}
                </strong>
              </p>
              <img
                  src="https://static.igem.wiki/teams/4260/wiki/safety-project/tables/table-6-different-treatments.png"
                  alt="Fig1-sp"
                  className="figure"
              />
              <p className="figure_desc ">
                <u>Note: each analysis was performed by triplicate. *</u>
              </p>
              <br></br>
              <p className="p-justify">
                Since the objective of the analysis through the Zetasizer was to
                determine a protocol that would provide a better homogenization of
                isoeugenol in the media, various statistical analyzes were carried
                out to find out the parameters that gave the best results. The
                main factor considered for this purpose was the distribution of
                the graphs produced by the equipment, seeking to have the least
                possible dispersion and, similarly, the desired size of the sample
                determined by the average peak. For this study he results of said
                peaks are shown in <strong>Figure 10</strong>.
              </p>
              <img
                  src="https://static.igem.wiki/teams/4260/wiki/safety-project/grafzetasizer.png"
                  alt="Fig1-sp"
                  className="figure"
              />
              <p className="figure_desc ">
                <strong><i>Figure 10. Peak means size per treatment, from 1 to 6.</i></strong>
              </p>
              <br></br>
              <p className="p-justify">
                Peaks means of <strong>Figure 10</strong> demonstrate those
                samples that would fit the best to the purpose in question, which
                would be treatment 4 and 6. Additionally, the error bars for these
                treatments show to be within the range with respect to the rest.
              </p>
              <p className="p-justify">
                For the evaluation of the distribution of the treatments, samples
                1-6 were analyzed and the graphs of the peaks that showed greater
                homogenization were generated, being treatment 4 (
                <strong>Figure 11</strong>) and 7 (<strong>Figure 12</strong>).
                This is because both treatments showed a significantly lower
                dispersion with respect to samples 1,2,3,5 and 6, showing a better
                homogenization.
              </p>
              <img
                  src="https://static.igem.wiki/teams/4260/wiki/safety-project/figura-14.png"
                  alt="Fig1-sp"
                  className="figure"
              />
              <p className="figure_desc ">
                <strong><i>
                  Figure 11. Particle size of isoeugenol treatment 4.</i>
                </strong>
              </p>
              <br></br>
              <img
                  src="https://static.igem.wiki/teams/4260/wiki/safety-project/figura-15.png"
                  alt="Fig1-sp"
                  className="figure"
              />
              <p className="figure_desc ">
                <strong><i>
                  Figure 12. Particle size of isoeugenol treatment 7.</i>
                </strong>
              </p>
              <br></br>
              <p className="p-justify">
                Comparing the methodologies of each treatment it can be inferred
                that the main factor for isoeugenol homogenization was sonication,
                which could be noted in various ways. On the one hand, it was
                concluded that the use of Tween 80 did not present interaction
                with the sample, that is, a change in the size of the micelles of
                the samples that contained it was not reported, and on the
                contrary, it was shown as a compound separately from isoeugenol.
                On the other hand, the use of water demonstrated the null
                interference of the LB medium in the analysis of the sample, that
                is, no change in sizes was reported when using one or the other.
                Finally, with the data obtained, it was possible to demonstrate
                that the use of the vortex did not greatly alter the degree of
                homogenization, since the distribution of the data remained within
                a similar range when it was used and when it was not used.
              </p>
              <p className="p-justify">
                Finally, another analysis that was made of the previously shown
                treatments, also using the Zetasizer, was the evaluation of the
                changes in the sample throughout the rest time of the sample,
                comparing 0 - 2 days. The distribution of the thrown graphs showed
                an increase as time passed, as shown in <strong>Figure 13</strong>{" "}
                and <strong>Figure 14</strong>.
              </p>
              <img
                  src="https://static.igem.wiki/teams/4260/wiki/safety-project/figura-16.png"
                  alt="Fig1-sp"
                  className="figure"
              />
              <p className="figure_desc ">
                <strong><i>
                  Figure 13, Particle size of isoeugenol treatment 9.</i>
                </strong>
              </p>
              <br></br>
              <img
                  src="https://static.igem.wiki/teams/4260/wiki/safety-project/figura-17.png"
                  alt="Fig1-sp"
                  className="figure"
              />
              <p className="figure_desc ">
                <strong><i>
                  Figure 14, Particle size of isoeugenol treatment 15.</i>
                </strong>
              </p>
              <br></br>
              <p className="p-justify">
                <em>1.6. Addition of isoeugenol</em>
              </p>
              <p className="p-justify">
                Although good results were obtained concerning the homogeneity of
                the culture mediums, one question remained: At which point of the
                procedure was it better to add isoeugenol into the mediums? Hence,
                the efficiency of three different treatments was tested:
              </p>
              <p className="p-justify">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;A: Addition of non-sterile
                isoeugenol before sterilization
              </p>
              <p className="p-justify">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;B: Addition of sterile isoeugenol
                after sterilization, before plating, similarly to antibiotics
              </p>
              <p className="p-justify">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;C: Addition of non-sterile
                isoeugenol after sterilization, before plating, similarly to
                antibiotics
              </p>
              <p className="p-justify">
                Serial dilutions x10<sup>-4</sup> and x10-5 of E. coli DH5α, were
                cultured by triplicate at concentrations shown in Table 3.
              </p>
              <br></br>
              <p className="figure_desc ">
                <strong>
                  Table 3. Isoeugenol concentrations used for treatments A, B and
                  C.
                </strong>
              </p>
              <img
                  src="https://static.igem.wiki/teams/4260/wiki/safety-project/tables/table-3-isoeugenol.png"
                  alt="Fig1-sp"
                  className="figure"
              />
              <p className="p-justify">
                After analyzing the growth behavior of serial dilutions in each
                treatment, we determined that results from treatments A and B were
                very similar, and due to inconsistencies treatment C was
                discarded. Despite the similarity between treatments A and B it
                was decided to keep up with treatment A because of the advantage
                of not having to manipulate the medium anymore after removing it
                from the sonicator.
              </p>
              <br></br>
              <hr></hr>
              <p className="p-justify">
                <em>
                  <u>
                    2) To evaluate the inhibitory effect of isoeugenol on the two
                    most used Escherichia coli strains: DH5α and BL21
                  </u>
                </em>
              </p>
              <img
                  src="https://static.igem.wiki/teams/4260/wiki/diluciones.jpg"
                  alt="Fig1-sp"
                  className="figure"
              />
              <p className="figure_desc ">
                <strong><i>
                  Figure 15. Serial dilutions in BL21 <em>E.coli</em> strain, at different isoeugenol concentrations.
                </i></strong>

              </p>
              <br></br>
              <p className="p-justify">
                The <strong>figure 15</strong> shows the results obtained from{" "}
                <em>E. coli</em> BL21 (with no genetic modification) growing in
                different isoeugenol concentrations (each corresponding
                concentration is shown in the white section under each image). For
                this experiment, serial dilutions of <em>E. coli</em> BL21 (0.6 of
                OD 600nm) were carried out until reaching cell concentrations of
                x10<sup>-5</sup> and x10<sup>-6</sup>.
              </p>
              <p className="p-justify">
                As it's shown, both negative controls had grown bacteria in big
                and thick colonies, as each colony showed a more intense white
                color, and major thickness, whilst the other plates presented
                an increase in the number of colonies but with a smaller size
                and opacity reduction with the increment of isoeugenol, this
                behavior can be observed in <b>Figure 16</b>. These features
                were quite notable, considering that the size of the
                colonies was reduced until there was no more growing on
                the plates with the highest concentration of this antibiotic.
              </p>
              <p className="p-justify">
                A more concise observation is that in both <em>E. coli</em>{" "}
                dilutions (x10<sup>-5</sup> and x10<sup>-6</sup>) spread in the
                petri dishes with the highest isoeugenol concentrations (4.5 mM
                and 5.5 mM), no growth was observed, since these increased
                isoeugenol concentrations avoided any development of the
                microorganisms, considering that the strain used does not count
                with a seleccion marker for this compound in its genome.
              </p>
              <p className="p-justify">
                In the previous figure it can be observed that there are notable
                differences between each type of dilutions, as it decreases, the
                colonies have a notable change with respect to their size and
                quantity, this can also be attributed in the same way to the
                concentration in which they are found, as it can be seen in the{" "}
                <strong>Figure 16</strong>.
              </p>
              <br></br>
              <img
                  src="https://static.igem.wiki/teams/4260/wiki/safety-project/tama-o-colonias.jpg"
                  alt="Fig1-sp"
                  className="figure"
              />
              <p className="figure_desc ">
                <strong><i>
                  Figure 16. Representation of the effect of different types of
                  concentrations of isoeugenol in BL21 strain.</i>
                  Each photograph was taken with a 6x zoom. The size, as well as intensity change of colonies can be observed.
                </strong>
              </p>
              <br></br>
              <p className="p-justify">
                Taking into account the previously mentioned in <b>Figure 16 </b>
                it can be seen a close-up of the results of the growth of <em>E.
                coli</em> BL21 without any resistance marker, with a 6x
                resolution. On the negative control plates, the colonies were
                big, opaque, and of a white/beige color, but as the isoeugenol
                concentration increased, the number of colonies decreased
                significantly, they became smaller and transparent, until
                the isoeugenol concentration became high enough to prevent
                them from develop and grow correctly (at 4.5 mM and 5.5 mM).
                Therefore, the 4.5 mM concentration of isoeugenol was defined
                as the Minimum Bactericidal Concentration (MLD), for solid
                medium. The same experiment was performed but with DH5α
                strains, nevertheless after repeating it several times,
                no concise results could be obtained.
                <br></br>
                <br></br>
                On the other hand, with respect to liquid medium, it was decided
                to use it for the evaluation of the behavior of DH5α. A seed
                culture of E. coli, grown overnight, it was seeded in fresh
                medium in a ratio of 1:40. Then 200 µl of the corresponding
                culture was placed in a 96-well plate. The plate was incubated
                in the Agilent BioTek Synergy H4 Hybrid Microplate Reader at 37°C
                with 200 rpm shaking, readings at 600 nm were scheduled every 20
                minutes for 16 hours.
                <br></br>
                <br></br>
                From the results shown in <strong>Figure 17</strong>, it was
                concluded that isoeugenol had a stronger effect when used in
                liquid medium, than it had when used with agar; this could be
                attributed to the availability of isoeugenol. In addition, it
                could be determined that the MIC and MLD values for liquid
                medium were 1.8 mM and 4.5 mM, respectively.
                <br></br>
                <img
                    src="https://static.igem.wiki/teams/4260/wiki/safety-project/exp-medio-liq.jpg"
                    alt="Fig1-sp"
                    className="figure"
                />
                <p className="figure_desc ">
                  <strong><i>
                    Figure 17. Growth kinetics of E. coli DH5α, at different concentrations of isoeugenol, in liquid medium.</i>
                  </strong>
                </p>
              </p>
              <p className="p-justify">
                The same experiment was performed but this time with DH5α strains,
                nevertheless after repeating them several times, a concise result
                couldn´t be obtained, each concentrations shown inconsistencies
                regarding the results obtained with BL21 strains.
              </p>

              <br></br>
              <hr></hr>
              <p className="p-justify">
                <em>
                  <u>
                    3) Characterization of the behavior of transformed cells with
                    our genetic constructs Pp_22 and Nc_22
                  </u>
                </em>
              </p>
              <p className="p-justify">
                <em>3.1 Ligation of the genetic constructs into a vector</em>
              </p>
              <p className="p-justify">
                Genetic constructs were inserted into pJET1.2 vector, in spite of
                this being a cloning vector and not an expression vector, using
                the CloneJET PCR Cloning Kit-Thermofisher Scientific (K1231). Both
                sequences included a promoter and a terminator for each gene.{" "}
                <strong>Figure 18</strong> and <strong>Figure 19</strong> show the{" "}
                <em>in silico </em>
                ligation of Pp_22 and Nc_22 in the EcoRV site of the vector. The
                selection of this vector resides on its ends facilitates ligation
                and resistance to Ampicillin.
              </p>
              <br></br>
              <img
                  src="https://static.igem.wiki/teams/4260/wiki/safety-project/clonaci-nbb6.png"
                  alt="Fig1-sp"
                  className="figure"
              />
              <p className="figure_desc ">
                <strong><i>
                  Figure 18. Ligation of Pp_22 (2807 bp) in pJET1.2.{" "}</i>
                </strong>
              </p>
              <br></br>
              <img
                  src="https://static.igem.wiki/teams/4260/wiki/safety-project/clonaci-nbb7.png"
                  alt="Fig1-sp"
                  className="figure"
              />
              <p className="figure_desc ">
                <strong>
                  Figure 19. Ligation of Nc_22 (1712 bp) in pJET1.2.{" "}
                </strong>
              </p>
              <br></br>
              <p className="p-justify">
                <em>3.2 Transformation of chemically competent cells</em>
              </p>
              <p className="p-justify">
                After this, both vectors were used to transform chemically
                competent cells DH5α and BL21 <em>E. coli</em> cells. Transformed
                cells were plated on LB with Ampicillin for the assuring the
                growth of them, then they were incubated at 37°C for 12 hours ,
                the results are reported in <strong>Table 4</strong>.
              </p>
              <br></br>
              <p className="figure_desc ">
                <strong>
                  Table 4. Growth results of transformed cells, plated on LB+Amp
                </strong>
              </p>
              <img
                  src="https://static.igem.wiki/teams/4260/wiki/safety-project/tables/table-4-growth-results.png"
                  alt="Fig1-sp"
                  className="figure"
              />
              <br></br>
              <p className="p-justify">
                <em>3.3 Plasmid extraction</em>
              </p>
              <p className="p-justify">
                Once the transformed colonies were obtained, a plasmid extraction
                was performed with the Quick Plasmid Miniprep Kit from Invitrogen.
                The results from the run in a 0.8% (w/v) agarose gel
                electrophoresis, are presented in <strong><i>Figure 20</i></strong>, as
                well as the <em>in silico</em> analysis (
                <strong><i>Figure 21</i></strong>).
              </p>
              <img
                  src="https://static.igem.wiki/teams/4260/wiki/safety-project/plasmid-extraction.png"
                  alt="Fig1-sp"
                  className="figure"
              />
              <p className="figure_desc ">
                <strong><i>
                  Figure 20. Plasmid extraction of transformed cells. 1)</i>
                </strong>{" "}
                1 kb DNA Ladder from NEB, <strong>2)</strong> Pp_22 DH5α 1,{" "}
                <strong>3)</strong> Pp_22 DH5α 2,
                <strong>4)</strong> Pp_22 DH5α 3, <strong>5)</strong> Pp_22 DH5α
                4, <strong>6)</strong> Pp_22 DH5α 5, <strong>7)</strong> Pp_22
                BL21, <strong> 8)</strong> Nc_22 DH5α 1,
                <strong>9)</strong> Nc_22 DH5α 2, <strong>10)</strong> Nc_22 BL211
                and <strong>11)</strong> Nc_22 BL21 2.
              </p>
              <br></br>
              <img
                  src="https://static.igem.wiki/teams/4260/wiki/safety-project/snapgene-simulation-plasmid.png"
                  alt="Fig1-sp"
                  className="figure"
              />
              <p className="figure_desc ">
                <strong><i>
                  Figure 21. SnapGene Simulation of 1) pJET+Pp_22 and 2)
                  pJET+Nc_22 migration in 0.8% agarose gel.{" "}</i>
                </strong>
                Both lanes show the supercoiled isoform of the plasmids.{" "}
                <strong>1)</strong> 5781 bp and <strong>2)</strong> 4686 bp.
              </p>
              <br></br>
              <p className="p-justify">
                <em>3.4 Digestions</em>
              </p>
              <p className="p-justify">
                The next step of the characterization was performing a series of
                digestion of the 10 plasmid samples; it was carried out with
                restriction enzymes <em>XbaI</em> and <em>SpeI</em>. The use of
                the same enzymes for all samples was possible due to the Biobrick
                design of both genetic sequences. The digestion product was
                analyzed with an electrophoresis (<strong><i>Figure 22</i></strong>) and
                a simulation (<strong><i>Figure 23</i></strong>) was also done in order
                to establish a comparison between both.
              </p>
              <img
                  src="https://static.igem.wiki/teams/4260/wiki/safety-project/digestions.png"
                  alt="Fig1-sp"
                  className="figure"
              />
              <p className="figure_desc ">
                <strong><i>
                  Figure 22. Digestion of plasmids with XbaI and SpeI. 1)</i>
                </strong>
                1 kb DNA Ladder from NEB, <strong>2)</strong> Pp_22 DH5α 1,
                <strong>3)</strong> Pp_22 DH5α 2, <strong>4)</strong> Pp_22 DH5α
                3, <strong>5)</strong> Pp_22 DH5α 4, <strong>6)</strong> Pp_22
                DH5α 5,
                <strong>7)</strong> Pp_22 BL21, <strong>8)</strong> Nc_22 DH5α 1,{" "}
                <strong>9)</strong> Nc_22 DH5α 2, <strong>10)</strong> Nc_22 BL211
                and
                <strong> 11)</strong> Nc_22 BL21 2.
              </p>
              <p className="figure_desc ">
                The gel was run with TE 1X at 110 V, for 60 min. Samples in lanes
                7, 8 and 9 were degraded.
              </p>
              <br></br>
              <img
                  src="https://static.igem.wiki/teams/4260/wiki/safety-project/simulations-digestions.png"
                  alt="Fig1-sp"
                  className="figure"
              />
              <p className="figure_desc ">
                <strong><i>
                  Figure 23. SnapGene Simulation of digestion of pJET+Pp_22 and
                  pJET+Nc_22 migration in agarose gel. 1)</i>
                </strong>{" "}
                pJET+Pp_22 shows two bands, one of 3009 bp and the other of 2728
                bp. <strong>2)</strong> pJET+Nc_22 shows a band of 3012 bp and
                another of 1630 bp.
              </p>
              <br></br>
              <p className="p-justify">
                <em>3.5 Polymerase Chain Reaction (PCR)</em>
              </p>
              <p className="p-justify">
                Polymerase Chain Reaction (PCR) was executed in order to observe
                the amplification of Pp_22 and Nc_22 using PF_HD22 and PR_HD22
                primers and be able to confirm their presence in the plasmids
                extracted from our transformed cells (<strong><i>Figure 24</i></strong>).
                This procedure, as well as the rest, was compared to the{" "}
                <em>in silico</em> simulation (<strong><i>Figure 25</i></strong>).
              </p>
              <img
                  src="https://static.igem.wiki/teams/4260/wiki/safety-project/pcrs.png"
                  alt="Fig1-sp"
                  className="figure"
              />
              <p className="figure_desc ">
                <strong><i>Figure 24. PCR with PF_HD22 and PR_HD22 primers.</i></strong>{" "}
                Lanes<strong> 2, 3, 4, 5 </strong>and <strong>6</strong>
                correspond to Pp_22, amplification products can be observed in all
                of them. Lanes <strong>7, 8, 9</strong> and <strong>10</strong>{" "}
                correspond to Nc_22, only lanes <strong>8</strong> and{" "}
                <strong>10</strong> show amplification products.
              </p>
              <br></br>
              <img
                  src="https://static.igem.wiki/teams/4260/wiki/safety-project/simulations-pcr.png"
                  alt="Fig1-sp"
                  className="figure"
              />
              <p className="figure_desc ">
                <strong><i>Figure 25. SnapGene Simulation of PCR. 1)</i></strong>{" "}
                pJET+Pp_22,<strong> 2) </strong> PCR product of pJET+Pp_22 (2808
                bp), <strong>3)</strong>
                pJET+Nc_22, and <strong>4)</strong> PCR product of pJET+Nc (1712
                bp)
              </p>
              <br></br>
              <p className="p-justify">
                <em>3.6 Isoeugenol monooxygenase expression analysis</em>
              </p>
              <p className="p-justify">
                After verifying the presence of the Pp_22 and Nc_22 in the
                transformed cells, the following samples were selected:{" "}
                <em>E. coli</em> DH5α transformed with Pp_22 (colonies 3, 4 and 5)
                and <em>E. coli</em> BL21 transformed with Nc_22 (colonies 1 and
                2). For preserving the cells and aiming to obtain better molecular
                results, glycerol aliquots of these were prepared when OD600 was
                0.6 for each.
              </p>
              <p className="p-justify">
                With these aliquotes, the expression of IsoMo was evaluated by
                culturing them in LB medium and a synthetic medium formulated with
                the intention of providing the cell with more iron (cofactor of
                IsoMo), at different concentrations of isoeugenol.
              </p>
              <p className="p-justify">
                Unfortunately, no difference in the band pattern was observed in
                neither DH5α and DH5α transformed with Pp_22, nor BL21 and BL21
                transformed with Nc_22 (<b><i>Figure 26</i></b>), indicating no
                expression of the enzyme.
              </p>
              <img
                  src="https://static.igem.wiki/teams/4260/wiki/safety-project/sds.png"
                  alt="Fig1-sp"
                  className="figure"
              />
              <p className="figure_desc ">
                <strong><i>Figure 26. SDS-PAGE of total protein samples.</i></strong>{" "}
                Transformed cells were cultured in LB with 2.5 mM of isoeugenol,
                whereas DH5α and BL21 in LB without isoeugenol. No difference was
                observed in the samples. <strong>1)</strong> Optic protein XL
                marker.
                <strong>2)</strong> BL21, <strong>3)</strong> DH5α,{" "}
                <strong>4)</strong> and <strong>5)</strong> DH5α transformed with
                Pp_22,
                <strong>6)</strong> and <strong>7)</strong> BL21 transformed with
                Nc_22.
              </p>
              <br></br>
              <p className="p-justify">
                IsoMo has an approximate size of 54 kDa thus a band of this size
                should be observed in all samples. Additionally, in samples
                corresponding to transformed cells with Pp_22 should also show a
                band of about 35 kDa that is the transcriptional activator (
                <em>IemR</em>) of Iso. Since none of them were observed in the
                results of the first experiment, it was decided to change a couple
                of things.
              </p>
              <p className="p-justify">
                Transformed cells and their controls were cultured in synthetic
                culture medium without isoeugenol and at 4.5 mM. After 72 hours of
                incubation, total protein was extracted again
                and samples were run in SDS-PAGE. However, nothing was shown in
                the gel, indicating that no cell growth was being obtained at 4.5
                mM and cells were dying in presence of isoeugenol because they
                were not producing IsoMo and, therefore, had no way of degrading
                it.
              </p>
            </div>
          </div>
          <Modal modalId="problem_moreInfo_modal1">
            <h3 className="h3">More Information</h3>
            <p className="p-justify">
              Tween 80 is a hydrophilic surfactant, which is commonly used for the
              emulsification of oil from water for its dispersión or
              solubilization, however, it has been shown to alter or enhance the
              antibacterial properties of emulsified compounds according to the
              concentrations of both substances. Krogsgård Nielsen, et al., (2017)
              demonstrated that adding Tween80 with a concentration of 0.5% of
              pure isoeugenol decreased its antimicrobial efficiency. [11]
            </p>
          </Modal>
          <Modal modalId="problem_moreInfo_modal3">
            <h3 className="h3">More Information</h3>
            <p className="p-justify">
              The Zetasizer has a big dinamic concentration capacity, and a high
              sensibility because of the non-invasive backscatter optical design
              (NIBS). The user can do measurements of particle and molecular size,
              electrophoretic mobility, zeta potential and molecular weight
              without complications. It has an optical filter wheel with
              fluorescence filter to allow measurement of fluorescent samples
              without compromising the overall sensitivity of the system, also
              includes polarizing filters for DDLS scattering measurements.
            </p>
            <p className="p-justify">
              You can perform any of the following examinations:
            </p>

            <p className="p-justify">
              <ul></ul>
              <li>
                Dynamic Light Scattering (DLS), to measures the size of particles
                and molecules
              </li>
            </p>

            <p className="p-justify">
              <li>
                Electrophoretic Light Scattering (ELS), to measure the zeta
                potential, indicates the stability of trend of samples to be
                added.
              </li>
            </p>
            <p className="p-justify">
              <li>
                Non-invasive Back Scattering (NIBS) optics, it is used for
                versatile and highly sensitive measurements of molecular and
                particle size as well as molecular weight.
              </li>
            </p>
            <p className="p-justify">
              <li>
                M3-PALS with constant current mode to measure zeta potential and
                electrophoretic mobility
              </li>
            </p>
            <p className="p-justify">
              <li>
                Optional MPT-3 autotitrator allows study of the effects of pH
                changes.{" "}
              </li>
            </p>
          </Modal>
        </PageWithGif>

        <PageWithGif
            gifURL={
              "https://static.igem.wiki/teams/4260/wiki/safety-project/1-safety-fondosolution-2.gif"
            }
        >
          <div className="relative h-full w-full flex justify-center items-end text-white">
            <div
                className="absolute rounded-xs p-16 m-auto"
                style={{
                  overflow: "scroll",
                  top: 0,
                  left: 0,
                  width: "70%",
                  height: "70%",
                  bottom: 0,
                  right: 0,
                  backgroundColor: "rgba(69, 41, 107,0.70)",
                  textAlign: "justify",
                }}
            >
              <h1
                  className="mb-5 text-6xl font-bold"
                  style={{ fontFamily: "Cano", color: "rgb(255, 231, 135)" }}
              >
                Implementation
              </h1>
              <p className="p-justify">
                <em>Overall scenario</em>
              </p>
              <p className="p-justify">
                Taking into account all of the previously reviewed, we consider
                that this innovative proposal for the substitution of antibiotics
                in synthetic biology experimental procedures, could help not only
                other iGEM teams but also other scientists around the world, to
                make big contributions for the progress of science in a more
                secure way. Respect to the first ones, in order for other iGEM
                teams to develop more integral projects, they could do an
                introspection about antibiotics, their use, and determine that a
                very important task to achieve is relating this topic to{" "}
                <em>Dual use</em> and biosafety & biosecurity. Nowadays, the
                resistance of bacteria to traditional antibiotics in laboratory
                practices could highly endanger public health, that is why it is
                necessary to get rid of their usage.
              </p>
              <p className="p-justify">
                In this case, the main advantage of overcoming traditional
                antibiotics as biomarkers using isoeugenol is that this could
                prevent outside contamination for other living organisms, such as
                humans or other animals, considering that this could endanger
                their health and even their lives. Since alternatives to
                antibiotics in molecular biology are not very common in the
                pharmaceutical industry, when using our proposed selection system,
                in case some modificated microorganism leaves some laboratory
                installations by accident and unnoticed, the illness that it may
                cause to others could be treated with the common antibiotics,
                avoiding the generation of an epidemic that could be caused by
                antimicrobial resistance.
              </p>
              <br></br>
              <p className="p-justify">
                <em>Dual Use</em>
              </p>
              <p className="p-justify">
                Dual-use consists of carrying out a biological research aiming for
                some specific scientific purpose, but taking into account that the
                results could also be encompassed with misused practices and
                activities to pose a biological threat to the world population.
              </p>
              <br></br>
              <img
                  src="https://static.igem.wiki/teams/4260/wiki/safety-project/dualuse-safetyproject.png"
                  alt="Fig1-sp"
                  className="figure"
              />
              <br></br>
              <p className="p-justify">
                <em>Advantages</em>
              </p>
              <p className="p-justify">
                Regarding the aim of this project being the substitution of common
                antibiotics in experimental procedures, a good application would
                be carrying out the genetic modification of <em><i>E. coli</i></em>, in
                this case with isoeugenol monooxygenase, in order to avoid a dangerous spread
                of this resistant bacteria to traditional antibiotics like
                ampicillin, penicillin, and others. If at any given moment it got
                out of the laboratory, no alarming situations would be
                encountered. The main advantage would be the application of a new
                selection system that would ensure the proliferation of only
                transformed cells, in a more secure way.
              </p>
              <br></br>
              <p className="p-justify">
                <em>Disadvantages</em>
              </p>
              <p className="p-justify">
                As in any scientific project, the purpose is to implement an
                alternative solution to a global problem. Therefore, all
                manipulated information is provided only for this purpose. But, if
                the information provided were intended to be misused, it could
                lead to the misunderstanding of how to manipulate antimicrobial
                resistance for the design of a pathogenic, genetically modified
                microorganism with resistance to modern medicine and common
                antibiotics, with the possibility of causing damage to the health
                of the population.
              </p>
              <p className="p-justify">
                So, for that instance, an alternative to these kind of selection
                markers could help us prevent this scenario, by the use of
                Isoeugenol which, as previously mentioned, represents clear
                advantages like the fact that it is not hazardous for neither
                humans, nor the environment. However, these are not the only ones.
              </p>
              <br></br>
              <hr></hr>
              <p className="p-justify">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <em>1) Isoeugenol is also a more economical option</em>
              </p>
              <p className="p-justify">
                When designing this project, the cost-effectiveness relation was
                widely considered because one of our main objectives was to
                motivate others to implement this system in their experiments.
                Thus, the price of isoeugenol was compared to one of the most
                world-widely used antibiotics: ampicillin, this data is presented
                in <strong>Table 5</strong>; however, 1 kg of isoeugenol was
                purchased at 40 USD from BioDerivados, in Mexico City.
              </p>
              <br></br>
              <p className="figure_desc ">
                <strong>
                  Table 5. Cost comparison between Ampicillin and Iosugenol (data
                  from Merck)
                </strong>
              </p>
              <img
                  src="https://static.igem.wiki/teams/4260/wiki/safety-project/tables/table-5-cost-comparisonn.png"
                  alt="Fig1-sp"
                  className="figure"
              />
              <br></br>
              <hr></hr>
              <p className="p-justify">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <em>2) The amounts needed are small</em>
              </p>
              <p className="p-justify">
                The maximum value of the MIC reported in literature, for{" "}
                <em>E. coli</em> was 3.65 mM [10], corresponding to 550 µL per
                liter of medium. In our case, the highest concentration used and
                the selected one as the MLD was 4.5 mM, corresponding to 684 µL
                per liter of medium.
              </p>
              <br></br>
              <hr></hr>
              <p className="p-justify">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <em>3) High-temperature resistance</em>
              </p>
              <p className="p-justify">
                According to the information reported in PubChem (Compound CID:{" "}
                <a
                    className="underline text-blue-600"
                    href="https://pubchem.ncbi.nlm.nih.gov/compound/853433"
                >
                  853433
                </a>
                ), the boiling point of isoeugenol is 266 °C (511 °F), which
                allowed the sterilization of the mediums with isoeugenol already
                included in the formulation. Antibiotics, on the other hand, are
                very thermolabile compounds that lose their properties if added to
                the medium when it is not cold enough.
              </p>
            </div>
          </div>
        </PageWithGif>
        <PageWithGif
            gifURL={
              "https://static.igem.wiki/teams/4260/wiki/safety-project/2-safety-fondodesign-1.gif"
            }
        >
          <div className="relative h-full w-full flex justify-center items-end text-white">
            <div
                className="absolute rounded-xs p-16 m-auto"
                style={{
                  overflow: "scroll",
                  top: 0,
                  left: 0,
                  width: "70%",
                  height: "70%",
                  bottom: 0,
                  right: 0,
                  backgroundColor: "rgba(69, 41, 107,0.70)",
                }}
            >
              <h1
                  className="mb-5 text-6xl font-bold"
                  style={{ fontFamily: "Cano", color: "rgb(255, 231, 135)" }}
              >
                Further steps
              </h1>
              <p align="justify">
                Due to time matters, the ending of this project could not be achieved as desired. However, the tests performed through the year allowed us to
                learn a lot about its opportunity areas, as well as its strengths. By analyzing the results obtained, it was possible for us to understand
                what measures need to be taken in order to make it work, and these are presented below.
              </p>
              <br></br>
              <hr></hr>
              <p align="justify">
                <em><u>1) Measurement/evaluation of the effectiveness of the transcription elements of both constructs</u></em>
              </p>
              <p align="justify">
                One of the possible reasons for the lack of expression of IsoMo is the low effectiveness of the transcription elements present
                in the genetic constructs. In the particular case of Pp_22 (<a className="underline text-blue-600" href="http://parts.igem.org/Part:BBa_K4260006">BBa_K4260006</a>),
                the sequence contains as transcription factors: <em>IemR</em>,
                the transcriptional activator of IsoMo, and the promoter, specific for the transcription of both <em>IemR</em> and Iso
                (the coding gene for IsoMo): it is important to mention that these elements are originary from <em>Pseudomonas nitroreducens</em> Jin1,
                whose IsoMo’s coding gene corresponds to “Iem”, whereas the one we are using to obtain IsoMo is coded by “Iso”, from <em>Pseudomonas
                putida</em> IE27.
              </p>
              <p align="justify">
                When elaborating the design of this project, the sequence alignment of Iso
                (GenBank: <a className="underline text-blue-600" href="https://www.ncbi.nlm.nih.gov/protein/BAF62888.1">BAF62888.1</a>) and Iem
                (GenBank: <a className="underline text-blue-600" href="https://www.ncbi.nlm.nih.gov/protein/227015876">ACP17973.1</a>)
                in EMBOSS Needle indicated that these genes are 80% identical, leaving a gap of 20% that could interfere with the effectiveness of the
                transcriptional regulation. Therefore, we propose the insertion of only IsoMo’s coding sequence in an expression vector. By inserting <i>Iso</i> in an expression vector, such as pET17b, the expression of the enzyme might indicate whether the problem resides on transcriptional elements or on the coding sequence itself. For this purpose, two primers would be necessary, in order to insert by PCR convenient restriction sites flanking <i>Iso</i>. Nevertheless, using a pET vector implies the limitation of its usage only with <i>E. coli</i> strains able to produce T7 RNA polymerase, which means that <i>E. coli</i> DH5α could not be used for this.


              </p>
              <p align="justify">
                Another way of measuring the strength of the inducible system, regulated by the bidirectional promoter region and the transcriptional activator,
                consists of the insertion of another reporter gene under the same promoter. With this in mind, the design of a genetic construct with the
                reporter gene of Red Fluorescent Protein (RFP) could be useful, as well as the strategy to fusion Pp__22 and RFP without the need of its
                synthesis from scratch.
              </p>
              <br></br>
              <hr></hr>
              <p align="justify">
                <em><u>2) Testing of other Isoeugenol monooxygenase sequences</u></em>
              </p>
              <p align="justify">
                As mentioned before, there are other enzymes, similar to isoeugenol monooxygenase that might be equally or even more efficient for the
                transformation of isoeugenol to vanillin. Perhaps, a monooxygenase from a genetically more similar to <em>E. coli</em> microorganism could facilitate
                its recombinant expression.
              </p>
              <img
                  src="https://static.igem.wiki/teams/4260/wiki/safety-project/other-monooxygenases.png"
                  alt="Fig1-sp"
                  className="figure"
              />
              <p className="figure_desc ">
                <strong><i>Figure 27. Other monooxygenases found in different microorganisms.</i></strong>
              </p>
              <p align="justify">
                <br></br>
                <hr></hr>
                <br></br>
                <em><u>3) Future vision</u></em>
              </p>
              <p align="justify">
                As a solution to the problem previously mentioned about the inappropriate and excessive use of antibiotics,
                the implementation of an alternative to practices that could promote future antibiotic resistance is proposed;
                however, for such execution to take place, a strategic, functional, and viable plan is necessary. Given this
                situation, it is suggested the evaluation of the impact that it would have, considering the sustainability,
                biosafety, innovation, and feasibility of its implementation.
              </p>
              <p align="justify">
                Compared to conventional selection markers, the differentiator of isoeugenol corresponds to its synthesis, since
                it is of natural origin, unlike those currently on the market, which are generally synthetic or semi-synthetic.
                This is a compound that presents diverse advantages such as its resistance to high temperatures, easy handling,
                and storage, as it does not present a risk of genotoxicity. This, in addition to being easily acquired as it is
                of biological origin (from cinnamon and cloves), represents a potential sustainable, innovative, and safe
                antibiotic compound.
              </p>
              <p align="justify">
                First of all, to consider the use of the compound as a product, it is necessary to examine its obtention method
                as well as its availability on the market. Isoeugenol is currently widely used industrially as a flavoring agent,
                and detergent and as a starting material for the synthesis of vanillin using microorganisms [19], so it is
                already a substance that is on the market. Likewise, it should be mentioned that the amounts required for the
                proposal in question are not exorbitant or excessive.
              </p>
              <p align="justify">
                Thus, with the previously mentioned, it can be inferred that the residues that would be generated directly from
                the compound when used as a selectable marker would correspond to vanillin and that, properly carrying out the
                corresponding treatment, it could be part of the raw material of another process, contributing to the search for
                the circular economy of processes.
              </p>
              <p align="justify">
                The process of the product in question would belong to a circular economy by minimizing the generation of waste
                and extending the life cycle of the compound. In this sense, the use of isoeugenol would cover the fundamental
                axes of sustainability: environmental, social, and economic [20]. This is because, in addition to the use of
                the waste generated, it would also ensure compliance with a basic need for humans: health, since, in addition
                to the resolution of the previously mentioned health emergency, isoeugenol has not been reported as a genotoxic
                or potentially dangerous compound.
              </p>
              <p align="justify">
                Although positive results were raised throughout this project, for the correct implementation of isoeugenol as an
                alternative to the currently used selectable markers, further studies are required to specifically determine the
                microorganisms and their respective strains in which it presents an antibiotic effect as well as to standardize
                the necessary concentrations for it. Therefore, it is proposed to consider the raised methodologies for the
                investigation and development of isoeugenol as a new and efficient selectable marker.
              </p>
              <br></br>
              <img
                  src="https://static.igem.wiki/teams/4260/wiki/safety-project/future-vision.png"
                  alt="Fig1-sp"
                  className="figure"
              />
              <p align="justify">
                With this in mind, our team believes that this project has the potential to become an entrepreneurship in the
                future, offering our “selection system kit” to scientists, having as a mission to contribute to the reduction
                of antimicrobial resistance. around the world. Our kit would represent a clear advantages against antibiotics:
                isoeugenol is a cheaper compound whereas antibiotics are expensive, and there would be no risk of inactivating
                the compound because of exposure to high temperature, because isoeugenol is very resistant.
              </p>
              <p align="justify">
                Besides, considering that isoeugenol causes inhibition on fungi species and yeasts, if more studies were run
                as well as  a better characterization of the action mechanism of isoeugenol and isoeugenol monooxygenase,
                this selection system could be used for different types of cloning.
              </p>
            </div>
          </div>
        </PageWithGif>

        <PageWithGif
            gifURL={
              "https://static.igem.wiki/teams/4260/wiki/safety-project/3-implementation-safety-compressed-1.gif"
            }
        >
          <div className="relative h-full w-full flex justify-center items-end text-white">
            <div
                className="absolute rounded-xs p-16 m-auto"
                style={{
                  overflow: "scroll",
                  top: 0,
                  left: 0,
                  width: "70%",
                  height: "70%",
                  bottom: 0,
                  right: 0,
                  backgroundColor: "rgba(69, 41, 107,0.70)",
                  textAlign: "justify",
                }}
            >
              <h1
                  className="mb-5 text-6xl font-bold"
                  style={{ fontFamily: "Cano", color: "rgb(255, 231, 135)" }}
              >
                References
              </h1>
              <p className="reference">
                [1] Das, A., Thakur, S., Shukla, A., Singh, P., Ansari, J., &
                Singh, N. P. (2020). Genetic transformation. En Chickpea: Crop
                Wild Relatives for Enhancing Genetic Gains (pp. 205–224).
                Elsevier. https://doi.org/10.1016/b978-0-12-818299-4.00008-7{" "}
              </p>
              <br></br>
              <p className="reference">
                [2] Jones, H. D. (2003). GENETIC MODIFICATION | Transformation,
                General Principles. En Encyclopedia of Applied Plant Sciences (pp.
                377–382). Elsevier. https://doi.org/10.1016/b0-12-227050-9/00197-6
              </p>
              <br></br>
              <p className="reference">
                [3] Suárez, C. & Gudiol, F. (2009). Antibióticos betalactámicos.
                Formación médica continua. 10.1016/j.eimc.2008.12.001
              </p>
              <br></br>
              <p className="reference">
                [4] Bush, K. & Bradford, P. (2016). β-Lactams and β-Lactamase
                Inhibitors: An Overview. Cold Spring Harbor Perspectives in
                Medicine. 10.1101/cshperspect.a025247
              </p>
              <br></br>
              <p className="reference">
                [5] Frieri, M., Kumar, K. & Boutin, A. (2017). Antibiotic
                resistance. Journal of Infection and Human Health. Vol. 10. Issue
                4. https://doi.org/10.1016/j.jiph.2016.08.007
              </p>
              <br></br>
              <p className="reference">
                [6] de Kraker, M., Stewardson, A. & Harbarth, S. (2016). Will 10
                Million People Die a Year due to Antimicrobial Resistance by 2050?
                PLoS Med 13(11): e1002184.
                https://doi.org/10.1371/journal.pmed.100218
              </p>
              <br></br>
              <p className="reference">
                [7] Jasovský, D., Littman, J., Zorzet, A. & Cars, O. (2016).
                Antimicrobial resistance-a threat to the world’s sustainable
                development. Taylor & Francis.
                https://doi.org/10.1080/03009734.2016.1195900
              </p>
              <br></br>
              <p className="reference">
                [8] Schmidt, E., et.al. (2013). Composition and Antioxidant
                Activities of the Essential Oil of Cinnamon (Cinnamomum zeylanicum
                Blume) Leaves from Sri Lanka. Journal of Essential Oil Bearing
                Plants. Vol. 9. Issue 2.
                https://doi.org/10.1080/0972060X.2006.10643490
              </p>
              <br></br>
              <p className="reference">
                [9] Overhage, J., Steinbüchel, Al. & Priefert, H. (2003). Highly
                Efficient Biotransformation of Eugenol to Ferulic Acid and Further
                Conversion to Vanillin in Recombinant Strains of Escherichia coli.
                Applied and Environmental Microbiology.
                https://doi.org/10.1128/AEM.69.11.6569-6576.2003
              </p>
              <br></br>
              <p className="reference">
                [10] Hyldgaard, M., Mygind, T., Piotrowska, R., Foss, M. & Meyer,
                R. (2015). Isoeugenol has a non-disruptive detergent-like
                mechanism of action. Frontiers in Microbiology, 6.
                DOI:10.3389/fmicb.2015.00754
              </p>
              <br></br>
              <p className="reference">
                [11] Krogsgård Nielsen, C., Kjems, J., Mygind, T., Snabe, T.,
                Schwarz, K., Serfert, Y., & Meyer, R. L. (2017). Antimicrobial
                effect of emulsion-encapsulated isoeugenol against biofilms of
                food pathogens and spoilage bacteria. International Journal of
                Food Microbiology, 242, 7-12.
                https://doi.org/10.1016/j.ijfoodmicro.2016.11.002
              </p>
              <br></br>
              <p className="reference">
                [12] Zemek, J., Valent, M., Pódová,M., Košíková, B. & Joniak, D.
                (1987). Antimicrobial properties of aromatic compounds of plant
                origin. Folia Microbiol 32, 421–425 (1987).
                https://doi.org/10.1007/BF02887573
              </p>
              <br></br>
              <p className="reference">
                [13] Zemek, J., Košíková, B., Augustín, J., & Joniak, D. (1979).
                Antibiotic properties of lignin components. Folia Microbiologica,
                24(6), 483–486. DOI:10.1007/bf02927180
              </p>
              <br></br>
              <p className="reference">
                [14] Yamada, M., Okada, Y., Yoshida, T., & Nagasawa, T. (2008).
                Vanillin production using Escherichia coli cells over-expressing
                isoeugenol monooxygenase of Pseudomonas putida. Biotechnology
                letters, 30(4), 665-670.
              </p>
              <br></br>
              <p className="reference">
                [15] Fitzgerald, D., Stratford, M., Gasson, M., Ueckert, J., Bos,
                A. & Narbad, A. (2004). Mode of antimicrobial action of vanillin
                against Escherichia coli, Lactobacillus plantarum and Listeria
                innocua. Journal of Applied Microbiology. Voll. 97. Issue 1.
                https://doi.org/10.1111/j.1365-2672.2004.02275.x
              </p>
              <br></br>
              <p className="reference">
                [16] Ryu, J. Y., Seo, J., Park, S., Ahn, J. H., Chong, Y.,
                Sadowsky, M. J., & Hur, H. G. (2013). Characterization of an
                isoeugenol monooxygenase (Iem) from Pseudomonas nitroreducens Jin1
                that transforms isoeugenol to vanillin. Bioscience, biotechnology,
                and biochemistry, 120715.
              </p>
              <br></br>
              <p className="reference">
                [17] Singh, P., Sharma, L., Kulothungan, S. R., Adkar, B. V.,
                Prajapati, R. S., Ali, P. S. S., ... & Varadarajan, R. (2013).
                Effect of signal peptide on stability and folding of Escherichia
                coli thioredoxin. PloS one, 8(5), e63442.
              </p>
              <br></br>
              <p className="reference">
                [18] Ryu, J. Y., Seo, J., Ahn, J. H., Sadowsky, M. J., & Hur, H.
                G. (2012). Transcriptional control of the isoeugenol monooxygenase
                of Pseudomonas nitroreducens Jin1 in Escherichia coli. Bioscience,
                biotechnology, and biochemistry, 76(10), 1891-1896.
              </p>
              <br></br>
              <p className="reference">
                [19] Hernández, et. al. (2017). Obtención de dehidro isoeugenol por dimerización de isoeugenol con cultivos celulares de Bouvardia ternifolia (trompetilla). TIP Revista 3 Especializada en Ciencias Químico-Biológicas. https://doi.org/10.1016/j.recqb.2017.04.002
              </p>
              <br></br>
              <p className="reference">
                [20] Monforte, G.A, Hartmann, A. & Farías, G. (s.f.). Declaraciones institucionales y percepciones individuales sobre la sustentabilidad en escuelas de negocios mexicanas. Contaduría y Administración, UNAM. http://dx.doi.org/10.1016/j.cya.2016.04.006            </p>
              <br></br>
            </div>
          </div>
        </PageWithGif>
      </div>
  );
}
